import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-accent-50 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-sm font-black text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                51<span className="text-primary-600">瓜网</span>
              </span>
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-6 text-foreground-600">
              聚合影视、综艺、明星动态与娱乐热点的吃瓜资讯入口，一个页面看齐当天值得关注的盘点与动态。
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-wechat-line", "ri-qq-line", "ri-mail-line", "ri-article-line"].map((c) => (
                <a
                  key={c}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
                  aria-label="社交入口"
                >
                  <i className={`${c} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">栏目导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/library?cat=${c.id}`}
                    className="inline-flex items-center gap-2 text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className={`${c.icon} text-accent-600`}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">快速入口</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-primary-700">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/library" className="text-foreground-600 transition-colors hover:text-primary-700">
                  资料库 · 全部内容
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-foreground-600 transition-colors hover:text-primary-700">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-600"></i>
                <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-primary-700">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-600"></i>
                <span>内容与投稿咨询，工作日 09:00 - 18:00 回复</span>
              </li>
            </ul>
            <div className="mt-4 rounded-xl bg-background-50 p-3 text-xs leading-5 text-foreground-500">
              本站为内容聚合整理网站，资讯均以公开信息为准；如涉及作品版权，欢迎来信沟通。
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-accent-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 {siteInfo.name} · 不想漏瓜，一个入口看齐
          </p>
          <p className="text-xs text-foreground-500">让每一次吃瓜都轻松一点 · 内容持续整理中</p>
        </div>
      </div>
    </footer>
  );
}